export const VOLUME_SLIDER_DEFAULT_DIALOG_STYLE = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  background: 'transparent',
  borderRadius: '40px',
  width: '100%',
  height: 'auto',
  position: 'absolute',
  top: '-12px',
  left: 0,
  transform: 'translateY(-100%)'
};

// Vertical padding is small because we have margins on the slider to allow the cursor to go up to its mid point.
// The margins are cursorSize/2, so it also changes on breakpoints
export const VOLUME_SLIDER_STYLE = {
  default: { cursorSize: 18, trackSize: 114, verticalPadding: 3, horizontalPadding: 14 },
  medium: { cursorSize: 18, trackSize: 96, verticalPadding: 3, horizontalPadding: 13 },
  small: { cursorSize: 14, trackSize: 70, verticalPadding: 3, horizontalPadding: 9 }
};

export const VOLUME_HIDDEN_STYLES = {
  opacity: 0,
  height: 0,
  overflow: 'hidden',
  /**
   * ‼️⚠️‼️ border => NONE
   *
   * Needed to cancel the border applied by the "ftv-magneto--glass". If not, the element remains
   * hoverable thanks to its border instead of be fully disabled.
   *
   * NB : Display NONE should have been easier, but cannot be used here because the slider wouldn't take
   * the focus on keyboard tabulation and wouldn't opened
   */
  border: 'none'
};

export const VOLUME_VISIBLE_STYLES = {
  opacity: 1,
  height: 'auto'
};

export const VOLUME_SLIDER_BUTTON_SEPARATOR = {
  position: 'absolute',
  bottom: '-12px',
  width: '100%',
  height: '15px',
  borderRadius: 'inherit'
};
